// @ts-nocheck

import Papa from 'papaparse';
import { DataSet } from 'vis-data';

import csvEdges from './assets/edges.csv?raw';
import csvNodes from './assets/nodes.csv?raw';

// DOM tooltip for nodes
function makeNodeTooltip(n: any) {
  const box = document.createElement('div');

  const name = document.createElement('div');
  name.className = 'tt-name';
  name.textContent = n.label || n.id;
  box.appendChild(name);

  if (n.summary) {
    const sum = document.createElement('div');
    sum.className = 'tt-meta';
    sum.textContent = n.summary;
    box.appendChild(sum);
  }
  if (n.url) {
    const link = document.createElement('div');
    link.className = 'tt-meta';
    const a = document.createElement('a');
    a.href = n.url;
    a.target = '_blank';
    a.rel = 'noopener';
    a.textContent = 'Quelle öffnen ↗';
    link.appendChild(a);
    box.appendChild(link);
  }
  return box;
}

// DOM tooltip for edges (relation only; multiple -> one per line)
function makeEdgeTooltip(e: any) {
  const box = document.createElement('div');
  const parts = String(e.relation || e.label || '')
    .split(/[,;/|]/)
    .map((s) => s.trim())
    .filter(Boolean);
  if (!parts.length) parts.push('');
  const ul = document.createElement('ul');
  for (const p of parts) {
    const li = document.createElement('li');
    const line = document.createElement('span');
    line.className = 'tt-rel';
    line.textContent = p;
    li.appendChild(line);
    ul.appendChild(li);
  }
  box.appendChild(ul);
  if (e.url) {
    const link = document.createElement('div');
    link.className = 'tt-meta';
    const a = document.createElement('a');
    a.href = e.url;
    a.target = '_blank';
    a.rel = 'noopener';
    a.textContent = 'Quelle öffnen ↗';
    link.appendChild(a);
    box.appendChild(link);
  }
  return box;
}

export const loadData = () => {
  // ---------- load data ----------
  const [nodesRaw, edgesRaw] = [
    Papa.parse(csvNodes, {
      header: true,
      dynamicTyping: false,
      skipEmptyLines: true,
    }),
    Papa.parse(csvEdges, {
      header: true,
      dynamicTyping: false,
      skipEmptyLines: true,
    }),
  ];

  // ---------- map CSV rows ----------
  const nodes = nodesRaw.data.map((n: any) => ({
    id: String(n.id).trim(),
    label: n.label?.trim() || String(n.id).trim(),
    story: n.story?.trim() || 'default',
    type: n.type?.trim() || 'person',
    shape: n.image ? 'circularImage' : 'dot',
    image: n.image || undefined,
    size: n.image ? 30 : 12,
    summary: n.summary || '',
    url: n.url || null,
  }));

  const edges = edgesRaw.data.map((e: any) => ({
    from: String(e.source).trim(),
    to: String(e.target).trim(),
    label: '', // no inline labels; relation is in tooltip only
    relation: e.relation || '',
    width: e.weight ? Number(e.weight) : 1,
    arrows: { to: { enabled: true, scaleFactor: 0.6, type: 'arrow' } },
    url: e.url || null,
    smooth: false,
  }));

  // ---------- attach tooltips BEFORE DataSets ----------
  nodes.forEach((n: any) => {
    n.title = makeNodeTooltip(n);
  });
  edges.forEach((e: any) => {
    e.title = makeEdgeTooltip(e);
  });

  return { nodes: new DataSet(nodes), edges: new DataSet(edges) };
};
